import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core'
import { MarketplaceActionRequiredIssue } from 'src/app/account/services/issue'

@Component({
  selector: 'marketplace-action-required-issue',
  templateUrl: './marketplace-action-required-issue.component.html',
  styleUrls: ['./marketplace-action-required-issue.component.scss'],
  // Presentational leaf: every binding comes from @Input, so OnPush is safe and
  // skips re-checking this template on unrelated change detection passes.
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MarketplaceActionRequiredIssueComponent implements OnInit {
  @Input() issue: MarketplaceActionRequiredIssue = null

  constructor() {}

  ngOnInit() {}
}
